import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../api";
import { ui } from "../uiStyles";

export default function InvoicePaymentsReturn() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("refreshing");
  const [message, setMessage] = useState("Refreshing your payment status with Stripe...");

  useEffect(() => {
    async function refresh() {
      try {
        const data = await apiRequest("/billing/connect/status");

        if (window.gtag) {
          window.gtag("event", "stripe_connect_completed", {
            event_category: "conversion",
            event_label: "invoice_payments",
          });
        }

        if (
          data?.stripe_connect_charges_enabled &&
          data?.stripe_connect_payouts_enabled
        ) {
          setStatus("active");
          setMessage("Invoice Payments are active. Your customers can now pay invoices online.");
        } else {
          setStatus("pending");
          setMessage("Stripe received your onboarding. Some verification may still be pending.");
        }
      } catch (e) {
        setStatus("pending");
        setMessage("Stripe returned you to JobTelesis. Refresh status from Invoice Payments if needed.");
      }
    }

    refresh();
  }, []);

  const success = status === "active";

  return (
    <div style={ui.page}>
      <div style={{ ...ui.card, maxWidth: 980, margin: "30px auto", textAlign: "center" }}>
        <div
          style={{
            width: 90,
            height: 90,
            borderRadius: 999,
            margin: "0 auto 22px",
            background: success ? "#22c55e" : "#f5c542",
            color: "#061525",
            display: "grid",
            placeItems: "center",
            fontSize: 48,
            fontWeight: 900,
          }}
        >
          ✓
        </div>

        <h1 style={{ margin: 0, color: "#fff", fontSize: 38 }}>
          Invoice Payments Enabled
        </h1>

        <h2 style={{ marginTop: 12, color: success ? "#4ade80" : "#f5c542" }}>
          {success ? "Congratulations!" : "Onboarding Received"}
        </h2>

        <p style={{ color: "#dbeafe", fontSize: 18, maxWidth: 680, margin: "18px auto" }}>
          {message}
        </p>

        <div style={{ ...ui.card, marginTop: 28, textAlign: "left" }}>
          <h3 style={{ color: "#fff", marginTop: 0 }}>What happens next?</h3>
          <ul style={{ color: "#dbeafe", lineHeight: 1.8 }}>
            <li>Add Pay Online to invoices so customers can pay securely.</li>
            <li>Payments are deposited to your connected Stripe account.</li>
            <li>Stripe processing fees apply.</li>
            <li>JobTelesis fees follow your current invoice payments agreement.</li>
          </ul>
        </div>

        <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginTop: 28 }}>
          <button style={ui.primaryButton} onClick={() => navigate("/invoices")}>
            Go to Invoices
          </button>
          <button style={ui.secondaryButton} onClick={() => navigate("/clients-jobs")}>
            Go to Dashboard
          </button>
          <button style={ui.secondaryButton} onClick={() => navigate("/billing")}>
            View Payment Settings
          </button>
        </div>

        <p style={{ marginTop: 26, color: "#9fb0c3" }}>
          Your payment information is secure and managed by Stripe.
        </p>
      </div>
    </div>
  );
}
